import React from 'react';
import s from './SliderCard.scss';
// import { Slider } from "./slider";
import { LinkWrapper } from '../../../components/BaseComp';
import { FeedInstance, isFeedInstance } from '../../../models/feed';
import { isXPSPromotionInstance, isBaiduUnionPromotionInstance } from '../../../models/apis/promotion';
import { CisItem } from '../../../models/apis/batchCisApi';
import { genRands } from '../../../utils/spmHelper';
import { GodBox } from '../../AdGod';
import { genPCMCode } from '../../../utils/spmHelper';
import { setPicSize } from '../../../utils/img_cutter';
interface Props {
    dataSource: CisItem[]
}

const feedPic = (item: FeedInstance) => {
    let imgUrl = item.bigCover || item.cover || item.images[0];
    const defaultBg = "//statics.itc.cn/asm/prod/build/static/media/placeholder.60f21f24.png";
    imgUrl = imgUrl && setPicSize(imgUrl, 794, 396);
    return (
            <LinkWrapper href={item.url} className={s.imgWrap} data-spm-strict="true">
                <img src={imgUrl || defaultBg} className={!imgUrl && s.defaultBg || ''}/>
                <div className={s.titleWrapper}>
                    <p className={s.mainFeedTitle}>
                        {item.title}
                    </p>
                </div>
            </LinkWrapper>
    )
}

export const SliderCard = (props: Props) => {
    const { dataSource } = props;
    const adPlaceHodlers = dataSource.slice(8);
    let placeHolderFlag = -1;
    return (
        <div className={s.cardContainer + ' dsy'} style={{ height: 410 }}>
            <h3 className={s.title} />
            <div className={s.focusWrap} data-asm-new-slider="true">
                <div className="slider-wrapper" data-spm="top-fspic">
                    {dataSource && dataSource.slice(0, 5).map((item, index) => {
                        if (isFeedInstance(item)) {
                            return <div className='slider-item' key={item.title + index}>{feedPic(item)}</div>;
                        } else if (isXPSPromotionInstance(item)) {
                            const placeholder = adPlaceHodlers[++placeHolderFlag];
                            return (
                                <div key={item.id + index} className='slider-item'>
                                    <div 
                                       style={{display:"inline-block"}} 
                                       data-spm-type="resource"
                                       data-spm-content={genPCMCode(item)}>
                                         <GodBox width={397} height={198} dataSource={[item]}>
                                            {
                                                isFeedInstance(placeholder)
                                                    ? feedPic(placeholder)
                                                    : null
                                            }
                                        </GodBox>
                                    </div>
                                </div>
                            );
                        }
                        return <div key={index} className='slider-item'><li /></div>;
                    })}
                </div>
            </div>
            <div className={s.bottomPics} data-spm="top-pics">
                    {dataSource && dataSource.slice(5, 5 + 3).map((item, index) => {
                        if (isFeedInstance(item)) {
                            let imgUrl = item.bigCover || item.cover || item.images[0]
                            imgUrl = imgUrl && imgUrl.replace(/w_([\s\S]+?),/g, 'w_264,').replace(/h_([\s\S]+?),/g, 'h_174,')
                            return (
                                <div key={item.title + index} className={s.picItem}>
                                    <LinkWrapper href={item.url} className={s.link}>
                                        <div className={s.imgWrap}>
                                            <img src={imgUrl} />
                                        </div>
                                        <p>{item.title}</p>
                                    </LinkWrapper>
                                </div>
                            );
                        } else if (isBaiduUnionPromotionInstance(item)) {
                            const width=132,height=138,overflow='hidden';
                            return (
                                <div key={index} className={s.picItem} data-spm-type="resource">
                                    <div className={s.picItem}
                                            key={index} 
                                            data-w="220px" 
                                            data-h="184px"
                                            style={{ width, height,overflow}}
                                            data-genRands={genRands()}
                                            data-spm-content={genPCMCode(item)}
                                            data-spm-stop="nev"
                                            data-spm-strict="true"
                                            data-spm-type="resource"
                                            data-baidu-id={item.adData.id}
                                    >
                                    </div>
                                    {/* <iframe src={`//assp.sohu.com/page?baid=${item.adData.id}&aty=BAIDUUNION&child=${genRands()}`}
                                        width="132"
                                        height="138"
                                        frameBorder={'0'}
                                        marginWidth={0}
                                        marginHeight={0} 
                                    /> */}
                                </div>
                            );
                        }
                        return <div key={index} />;
                    })}
            </div>
        </div>

    );
};


// WEBPACK FOOTER //
// ./src/components/HomeTop/SliderCard/index.tsx